// Early avatar injection for the website navbar.
//
// frappe's render_user() injects the user avatar only on document.ready,
// which made the avatar flicker in/out while navigating (the li is rendered
// server-side with display:none). This file is loaded via web_include_js
// AFTER frappe-web.bundle but BEFORE DOMContentLoaded, so injecting here
// paints the avatar from the very first frame with the EXACT same markup
// that render_user() produces later (no visible swap).
//
// The CSS placeholder in navbar_flash_fix.css only covers the tiny window
// before this script runs (or when JS is disabled).
(function () {
	if (document.body.getAttribute("frappe-session-status") !== "logged-in") {
		return;
	}
	var wrapper = document.querySelector("#website-post-login .user-image-wrapper");
	if (!wrapper || wrapper.childElementCount) {
		return;
	}
	// same call as frappe-web.bundle render_user():
	// frappe.avatar(null, "avatar-medium", null, null, null, true)
	wrapper.innerHTML = frappe.avatar(null, "avatar-medium", null, null, null, true);
})();
